import { BlockView } from "common/views/block/BlockView.view";
import { ButtonView } from "common/views/button/Button.view";
import React from "react";
import CatalogLabels from "../Catalog.labels";
import { Variant } from "../entities/Course";


interface Ivariants {
    variants:Variant[];
    addTocart: (v: Variant) => void;
    toggleOpen: () => void;
    isRepurchase:boolean;//  Flag instructs this component to render either isPurchased variants or regular variants
}

 const RenderVariants=(props: Ivariants)=>{
    const variants = props.variants.map(variant => (
        props.isRepurchase===variant.repurchaseVariant &&
		<a>
			<div onClick={() => {props.addTocart(variant);props.toggleOpen();}}>
                <CatalogLabels.Labels.ShowVariants args={{price: variant.price, title: variant.title}}/>
			</div>
		</a>
	));

    return(
        <BlockView viewKey="course.variants">
            <ButtonView viewKey="close.variants" onClick={props.toggleOpen}/>
            {variants}
        </BlockView>
        
    )
}

export default RenderVariants;



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/renderVariants.tsx